import { DeeplinkEnvUrls } from './build-activity-deeplink.utils';

/**
 * Base urls for the miniapps this feed can route into, resolved from the FE .env.
 *
 * Static `process.env.*` reads, NOT a dynamic lookup, so the bundler can inline them — a computed key
 * would leave every one of these `undefined` in the build and silently un-route the whole feed.
 *
 * Shared rather than private to the deeplink hook because two questions now read them: where a module
 * url points, and whether a building's utility button points at that same place (VIS-2189).
 */
export const ENV_URLS: DeeplinkEnvUrls = {
  REACT_APP_SERVICE_BOOKING_URL: process.env.REACT_APP_SERVICE_BOOKING_URL,
  REACT_APP_EVENTS_MINIAPP_URL: process.env.REACT_APP_EVENTS_MINIAPP_URL,
  REACT_APP_RESOURCE_BOOKING_URL: process.env.REACT_APP_RESOURCE_BOOKING_URL,
  REACT_APP_WORK_ORDERS_END_USER_URL: process.env.REACT_APP_WORK_ORDERS_END_USER_URL,
  REACT_APP_VISITOR_REGISTRATION_URL: process.env.REACT_APP_VISITOR_REGISTRATION_URL,
};
